import { render, staticRenderFns } from "./BibliographyRealInfoMagazine.vue?vue&type=template&id=58854239&"
import script from "./BibliographyRealInfoMagazine.vue?vue&type=script&lang=ts&"
export * from "./BibliographyRealInfoMagazine.vue?vue&type=script&lang=ts&"
import style0 from "./BibliographyRealInfoMagazine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTooltip})
